module.exports = __webpack_public_path__ + "img/verady.8f264b6c.jpg";